module.exports = __webpack_public_path__ + "img/7.40a8164e.jpg";